import React from "react";
import {phaseColSpan} from "./analyticsUtils";

export default function ({reportAnalytics, enablePtoAnalytics}) {
  return (
    <tr>
      <th></th>
      {reportAnalytics.phases.map(phase => (
        <th data-align="center" key={phase.guid} colSpan={phaseColSpan(reportAnalytics, phase, enablePtoAnalytics)}>{phase.header}</th>
      ))}
      {!enablePtoAnalytics && <th>#</th>}
    </tr>
  )
}
